import Joi from 'joi';

import { UserTypeEnum } from '../../enums/user-type.enum';

/**
 * Schema for new user record validation.
 */
export const createUserSchema = () =>
	Joi.object({
		username: Joi.alternatives().conditional(Joi.any().valid(null), {
			then: Joi.invalid(null).messages({
				'any.invalid': 'validations|user-username|cannot-be-null',
			}),
			otherwise: Joi.string().required().messages({
				'any.required': 'validations|user-username|required',
				'string.base': 'validations|user-username|must-be-string',
				'string.empty': 'validations|user-username|cannot-be-null',
			}),
		}),
		email: Joi.alternatives().conditional(Joi.any().valid(null), {
			then: Joi.invalid(null).messages({
				'any.invalid': 'validations|user-email|cannot-be-null',
			}),
			otherwise: Joi.string()
				.email({ tlds: { allow: false } })
				.required()
				.messages({
					'any.required': 'validations|user-email|required',
					'string.base': 'validations|user-email|must-be-string',
					'string.email': 'validations|user-email|invalid',
					'string.empty': 'validations|user-email|cannot-be-null',
				}),
		}),
		type: Joi.alternatives().conditional(Joi.any().valid(null), {
			then: Joi.invalid(null).messages({
				'any.invalid': 'validations|user-type|cannot-be-null',
			}),
			otherwise: Joi.string()
				.valid(...Object.values(UserTypeEnum))
				.required()
				.messages({
					'any.required': 'validations|user-type|required',
					'any.only': 'validations|user-type|invalid-value',
					'string.base': 'validations|user-type|must-be-string',
					'string.empty': 'validations|user-type|cannot-be-null',
				}),
		}),
	})
		// Ignore extra fields
		.unknown();
